import { render, staticRenderFns } from "./panel-cover.vue?vue&type=template&id=595df6c9&"
import script from "./panel-cover.vue?vue&type=script&lang=js&"
export * from "./panel-cover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports